const dictionary = {
  'digital-learning': 'Digital Learning',
}

export default dictionary
